export const dashOrSpaceToUnderscore = <T extends string>(str: T): T =>
  str.replace(/[-\s]/g, '_') as T
